export default __webpack_public_path__ + "static/media/orchestrator_1.3060209d.png";